<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="$t('users.timelineTitle')">
        <template slot="actions">
          <va-button class="backButton" outline @click.prevent="toAppUsers" icon="fa fa-chevron-left"> {{ $t('users.cardTitle') }}</va-button>
        </template>
        <va-notification v-if="userTimelineError !== null" color="danger">
          <va-badge color="danger">
            {{ $t('badges.error') }}
          </va-badge>
          {{userTimelineError}}
        </va-notification>
        <!--        <va-notification v-if="theUserTimeline !== null" color="info">-->
        <!--          <va-badge color="info">-->
        <!--            info-->
        <!--          </va-badge>-->
        <!--          This user have not make any action yet.-->
        <!--        </va-notification>-->
      </va-card>
    </div>
    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card v-if="theUserTimeline.length < 1" stripe="primary">
        <div class="row">
          {{ $t('users.noActions') }}
        </div>
      </va-card>

      <va-card v-if="theUserTimeline.length > 0" no-padding-v>
        <va-timeline vertical centered style="min-width: 300px;">
          <va-timeline-item :color="getStatusColor(timeline.status)" active
            v-for="(timeline, idx) in theUserTimeline"
            :key="idx">
            <span
              slot="before"
              class="title title--danger va-timeline-item__text"
              :style="{color: getStatusHexColor(timeline.status)}"
            >
              {{timeline.dateTime | moment("MMMM Do YYYY HH:mm")}}
            </span>
            <va-card
              slot="after"
              :stripe="getStatusColor(timeline.status)"
              class="mb-0"
            >
              <template slot="title">{{timeline.status}} car {{timeline.name}}</template>
              {{getTimelineText(timeline.status, timeline.name, timeline.spot)}}
            </va-card>
          </va-timeline-item>
        </va-timeline>
      </va-card>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  name: 'AppUserTimeline',
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  data () {
    return {
      userId: undefined,
      userTimelineError: null,
      theUserTimeline: [],
    }
  },
  methods: {
    getPlate (plate) {
      return plate === null || plate.length < 1 ? this.$t('users.noPlate') : plate
    },
    getStatusColor (status) {
      if (status === 'taken') {
        return 'info'
      } else if (status === 'payment') {
        return 'info'
      } else if (status === 'request') {
        return 'warning'
      } else if (status === 'onthego') {
        return 'dark'
      } else if (status === 'awaiting') {
        return 'danger'
      } else if (status === 'completed') {
        return 'success'
      }
      return 'danger'
    },
    getStatusHexColor (status) {
      if (status === 'taken') {
        return this.$themes.info
      } else if (status === 'payment') {
        return this.$themes.info
      } else if (status === 'request') {
        return this.$themes.warning
      } else if (status === 'onthego') {
        return this.$themes.dark
      } else if (status === 'awaiting') {
        return this.$themes.danger
      } else if (status === 'completed') {
        return this.$themes.success
      }
      return this.$themes.danger
    },
    getStatusText (status) {
      if (status === 'taken') {
        return this.$t('users.statusParked')
      } else if (status === 'payment') {
        return this.$t('users.statusPaymentCompleted')
      } else if (status === 'request') {
        return this.$t('users.statusCarRequested')
      } else if (status === 'onthego') {
        return this.$t('users.statusOnTheGo')
      } else if (status === 'awaiting') {
        return this.$t('users.statusAwaitingClient')
      } else if (status === 'completed') {
        return this.$t('users.statusCompleted')
      }
      return status
    },
    getIpokoristikoText (status) {
      if (status === 'taken') {
        return this.$t('users.to')
      } else if (status === 'onthego') {
        return this.$t('users.for')
      } else if (status === 'awaiting') {
        return this.$t('users.for')
      }
      return ' '
    },
    getTimelineText (status, plate, spot) {
      return this.getStatusText(status) + this.$t('users.car') + this.getPlate(plate) + this.getIpokoristikoText(status) + this.$t('users.spot') + spot
    },
    initUserTimeline (userTimeline) {
      this.theUserTimeline.splice(0, this.theUserTimeline.length, ...userTimeline)
      this.$store.commit('setLoading', false)
    },
    toAppUsers () {
      this.$router.push({
        name: 'app-users',
      })
    },
    toDashboard () {
      this.$router.push({
        name: 'dashboard',
      })
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.userId = Number.parseInt(this.$route.params.userId)
    if (!this.userId) {
      this.toDashboard()
    }
    this.$store.dispatch('userTimeline', this.userId)
      .then((resp) => this.initUserTimeline(resp.data.message))
      .catch(error => this.errorHandler(error.response))
  },
}
</script>

<style scoped>

</style>
